export default "__VITE_ASSET__DUUH4J6i__"